import React from "react";
import FileTree from "./file-tree";
import FileBrowser from "./file-browser";
import BreadcrumbFile from "./bread-crumb-file";
import FileToolbar from "./file-toolbar";
import ShareEditor from "./share-editor";
import FileUpload from 'components/file-upload'
import { Search, Input, CopyClipboard } from "components/common";
import { getParents, updateFileWithHash, handleIcon, openFileInNewTab } from './filemanager-utils'

export default class FileManager extends React.Component {
	constructor(props) {
		super(props);
		this.state =  {
			selectedFiles: [],
			currentPath: [],
			searchTerm: "",
			currentFolder: null,
			canEdit: false,
			hasFolderSelected: false,
			filesToCopie: {
				files: [],
				isCutting: false
			},
			isContextMenuVisible: false,
			contextMenuPosition: { 
				top: 0, 
				left: 0
			},
			files: [],
			isFromEditor: props.isFromEditor || false,
			viewMode: localStorage.getItem("browser-list-view-mode") || "grid", // grid | list
			isCollapsedView: localStorage.getItem("browser-list-collapsed-view") === 'true' ? true : false,
		};
	}

	static Modal = (onSelected = null, onAdd = null) => {
		const showModal = () => {
			mbox.modal(
				<FileManager
					isFromEditor={true}  
					onSelected={onSelected}
					onOpen={onAdd}
				/>,
				{
					title: hp.store.title,
					className: "modal-lg",
					buttons: [
						{
							text: __('buttons_add'), 
							icon: 'la la-check', 
							type: 'primary',
							onClick: () => onAdd(null)
						},
						'close'
					]
				}
			);
		};
		if (!hp.store.hasOwnProperty('fileManager')) {
			http.get('/filesmanager/initFileManager.json', {}, (response) => {
				const { perms } = hp.store;

				// o intuito da dialog é para carregar ficheiros, logo o user deve ter sempre permissões para o efeito
				// independentemente das permissões definidas ao nível da aplicação
				perms.canRead = true;
				perms.canEdit = true;
				perms.canDelete = true;
				hp.store.fileManager = {};
				showModal();
			});
			return;
		}
		showModal();
	}

	componentDidMount() {
		const last_path = sessionStorage.getItem('fm_path') || hp.settings.fm_path;
		
		// se ainda não foram carregadas as configurações do fileManager
		if (!hp.store.hasOwnProperty('fileManager')) {
			http.get('/filesmanager/initFileManager.json', {}, () => {
				this.fetchFiles(last_path);
			});
			return;
		}
		this.fetchFiles(last_path);
	}

	onRefreshClicked = async () => {
		await this.handleOpenFile(this.state.currentFolder, true);
		this.setState(() => ({
			filesToCopie: {
				files: [],
				isCutting: false
			}
		}));
	   
	}   

	fetchFiles = async (target) =>  {
		http.get('/filesmanager/getFiles.json', { target: target }, (response) => {
			//const currentFolder = response.files.filter(item => item.hash == target)
			let currentFolder = response.path == 'shared' ? response.files[1] : null;

			if (response.files.length > 0 && currentFolder == null) {
				const xpath = response.path.split('/');
				currentFolder = response.files[0];
				// procura pelo currentFolder na lista de files
				for (let path of xpath) {
					currentFolder = currentFolder.children?.find((file => file.hash == path));
					if (!currentFolder) {
						currentFolder = response.files[0];
						//sessionStorage.setItem('fm_path', response.files[0].hash);
						break;
					}
				}
			}
			this.setState(() => ({
				//files: currentFolder.length ? currentFolder : response.files,
				files: response.files,
				selectedFiles: [],
				currentFolder: currentFolder,
				currentPath: currentFolder ? [...getParents(currentFolder.alias, response.files), currentFolder] : [],
			}));
		});
	};

	handleDoubleClick = async (selectedFile, forceRefresh = false) => {
		this.handleOpenFile(selectedFile, forceRefresh);
		if(!selectedFile.isFolder && this.props.onOpen) {
			this.props.onOpen([selectedFile]);
		}
	}

	handleOpenFile = async (selectedFile, forceRefresh = false) => {
		if(!selectedFile.isFolder) {
			if (this.state.isFromEditor && this.props.onSelected) {
				this.props.onSelected(selectedFile);
				return;
			}
			openFileInNewTab(selectedFile, false); 
			return;
		}

		if(!forceRefresh && selectedFile.hash == this.state.currentFolder.hash) {
			return;
		}
		
		const { files, filesToCopie, searchTerm } = this.state;

		if (Array.isArray(selectedFile.children) && !forceRefresh) {
			this.setState(() => ({
				currentFolder: selectedFile,
				selectedFiles: [],
				canEdit: filesToCopie.files.length ?? false,
				currentPath: [...getParents(selectedFile.alias, files), selectedFile],
			}));
		}
		else {
			http.get('/filesmanager/getChildren.json', { target: selectedFile.hash, isShared: selectedFile.isShared, searchTerm }, (response) => {
				const updatedFiles = updateFileWithHash(files, selectedFile.hash, response.current_folder.children);
				this.setState(() => ({
					files: updatedFiles,
					currentFolder: response.current_folder,
					selectedFiles: [],
					canEdit: filesToCopie.files.length ?? false,
					currentPath: [...getParents(response.current_folder.alias, files), selectedFile],
				}));
			});
		}
		// registar path
		sessionStorage.setItem("fm_path", selectedFile.hash);
	};

	handleSelectedRow = (selectedFiles, isMultipleSelection) => {
		const hasFolderSelected = selectedFiles.some(item => item.isFolder)
		if(!isMultipleSelection) {
			this.setState({ filesToCopie: {
				isCutting: false,
				files: []
			}});
		}
		
		this.setState({ selectedFiles, hasFolderSelected, canEdit: selectedFiles.length });
		if (this.state.isFromEditor && this.props.onSelected) {
			this.props.onSelected(selectedFiles);               
		}
	};

	onDuplicateClicked = async () => {
		const { selectedFiles } = this.state || {};
		const targets = selectedFiles.map(file => file.hash);
		http.post('/filesmanager/duplicateFolder.json', { targets: targets }, async (response) => {
		   await this.onRefreshClicked();
		});
	}

	onDeleteClicked = async () => {
		const { selectedFiles } = this.state || {};
		const filesToBeDeleted = selectedFiles.map(file => file.name).join('<br>');
		const targets = selectedFiles.map(file => file.hash);
		mbox.confirmDelete(
			() => {
				http.post('/filesmanager/deleteFile.json', { targets: targets }, async (response) => {
					await this.onRefreshClicked();
					mbox.dismiss();
				})
			},
			`:<br> ${filesToBeDeleted}. <br> ${__('files_confirm_delete_obs')}`
		)
	}

	onRenameClicked = async () => {
		const { selectedFiles } = this.state || {};
		if(selectedFiles.length > 1) {
			return;
		}
		const newFileName = {value: selectedFiles[0].name};
		mbox.show(
			<div className="pcontent">
				<Input name="value" model={newFileName} className="form-control" />
			</div>,
			__('files_rename'),
			"edit",
			[
				"cancel",
				{
					name: 'save',
					onClick: () => {
						http.post('/filesmanager/renameFile.json', { target: selectedFiles[0].hash, name: newFileName.value }, async () => {
							await this.onRefreshClicked();
							mbox.dismiss();
						})
					},
				},
			],
			() => this.forceUpdate()
		);
	}

	handleBreadcrumbClick = (folder) => {
		if (folder.alias === this.state.currentFolder.alias) {
			return;
		}
		this.setState(() => ({
			selectedFiles: [],
			currentFolder: folder,
			currentPath: [...getParents(folder.alias, this.state.files), folder],
		}));
	};

	handleSearchChange = (value) => {
		this.setState({ searchTerm: value }, () => {
			this.onRefreshClicked();
		});
	   
	};

	onNewFolderClicked = () => {
		const { currentFolder } = this.state || {};
		const newFolder = { value: '' };
		mbox.show(
			<div className="pcontent">
				<Input required placeholder={__('files_set_file_name')} name="value" model={newFolder} className="form-control" />
			</div>,
			"Nova pasta",
			"folder",
			[
				"cancel",
				{
					name: 'save',
					onClick: () => {
						if(!newFolder.value){
							mbox.error('Deve preencher o campo "nome da pasta"!', "Preencha o campo para continuar");
							return 
						}
						http.post('/filesmanager/createFile.json', { target: currentFolder.hash, name: newFolder.value }, async (response) => {
							await this.onRefreshClicked();
							mbox.dismiss();
						})
					},
				},
			],
			() => this.forceUpdate()
		);
	};

	onUploadClicked = async () => {
		const { currentFolder } = this.state || {};
		if(!currentFolder.hash) {
			return;
		}
		mbox.modal(
			<FileUpload handleFileToUpload={this.onRefreshClicked} uploadURL={`/filesmanager/uploadFiles.json?target=${currentFolder.hash}`}/>,
			{
				title: "Upload ...",
				buttons: []
			}
		)
	};

	onDownloadClicked = (file) => {
		const { selectedFiles } = this.state || {};
		// TODO: Para ja, apenas permite download de um ficheiro de cada vez e do tipo file, ou seja não folder. Mais tarde adicionar logica para fazer download de pasta, tem de converter para zip
		if(this.canDownload()) {
			openFileInNewTab(selectedFiles[0], true);
		}
	}

	canDownload = () => {
		const { selectedFiles } = this.state || {};
	   return selectedFiles.length == 1 && !selectedFiles[0].isFolder;
	}

	onCutClicked = () => {
		const { selectedFiles } = this.state || {};
		this.setState({ filesToCopie: {
			files: selectedFiles,
			isCutting: true,
		}});
	}

	onCopyClicked = () => {
		const { selectedFiles } = this.state || {};
		this.setState({ filesToCopie: {
			files: selectedFiles,
			isCutting: false,
		}});
	}

	onPasteClicked = async () => {
		const { filesToCopie, currentFolder } = this.state || {};
		const targets = filesToCopie.files.map(file => file.hash);
		const copyTo = currentFolder

		http.post('/filesmanager/pasteFile.json', { targets: targets, dst: copyTo.hash, isCutting: filesToCopie.isCutting }, async (response) => {
			await this.onRefreshClicked();
			this.setState({ filesToCopie: {
				files: [],
				isCutting: false,
			}});
			mbox.dismiss();
			
		})
	}

	onInfoClicked = async () => {
		const { currentPath, selectedFiles } = this.state || {};
		const info = selectedFiles[0];
		const title = info.name;
	   
		const filesizekb  = (info.size / 1024).toFixed(2);
		const filesizemb  = (filesizekb / 1024).toFixed(2);
		const size = filesizemb > 1 ? filesizemb +' Mb' : (filesizekb > 1 ? filesizekb +' Kb' : '') ;
		
		mbox.show(
			<div className="pcontent">
				<div className="row">
					<div className="col col-md-1 text-right">
						{ handleIcon(info) }
					</div>
					<div className="col col-md-11">
						<table className="table">
							<tbody>
								<tr>
									<td>{__('files_type')}</td>
									<td title="File">{info.isFolder ? 'Folder' : 'File'}</td>
								</tr>
								{
									size ? 
									<tr>
										<td>{__('files_size')}</td>
										<td>
											<span title={size}>{size}</span>
										</td>
									</tr>  : null
								}
								<tr>
									<td>{__('files_path')}</td>
									<td>{`${currentPath.map(item => item.name).join('/')}/${title}`}</td>
								</tr>
								<tr>
									<td>{__('files_modified')}</td>
									<td>{info.updated_at}</td>
								</tr>
								<tr>
									<td>{__('files_module')}</td>
									<td className="text-capitalize">{info.module}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>,
			title,
		);
	}

	toggleViewMode = () => {
		this.setState((prevState) => {
			const newViewMode = prevState.viewMode === "grid" ? "list" : "grid";
			localStorage.setItem('browser-list-view-mode', newViewMode);

			return { viewMode: newViewMode };
		});

		this.setState({selectedFiles: []});
	};

	onOpen = (file) => {
		if(file.isFolder) {
			this.handleOpenFile(file, true);
			return
		}

		openFileInNewTab(file);
	}

	handleContextMenuOption = (option, file) => {
		switch (option) {
			case 'open':
				this.onOpen(file);
				break;
			case 'refresh':
				this.onRefreshClicked();
				break;
			case 'cut':
				this.onCutClicked()
				break;
			case 'copy':
				this.onCopyClicked()
				break;
			case 'paste':
				this.onPasteClicked(file)
				break;
			case 'newFolder':
				this.onNewFolderClicked()
				break;
			case 'delete':
				this.onDeleteClicked()
				break;
			case 'rename':
				this.onRenameClicked()
				break;
			case 'info':
				this.onInfoClicked()
				break;
			case 'share':
				this.onShareClicked(file);
				break;
			case 'download':
				openFileInNewTab(file, true);
				break;
			case 'copyUrl':
				CopyClipboard(file.url, __('files_copied_clipboard'));
				break;
			default:
				console.log('unkown context menu action', option, file);
				break;
		}
	}

	onShareClicked = (file = false) =>  {
		let selectedFile;
		if(file && !Array.isArray(file) && file.alias) {
		   selectedFile = [file];
		}
	
		const targets = selectedFile ? selectedFile : this.state.selectedFiles
		mbox.show(
			<ShareEditor targets={targets} />,
			'Partilhar',
			null,
			null,
			() => this.onRefreshClicked()
		);   
	}

	onCollapsed = () => {
		this.setState((prevState) => {
			localStorage.setItem('browser-list-collapsed-view', !prevState.isCollapsedView);

			return { isCollapsedView: !prevState.isCollapsedView};
		});
	};
	
	get isGridView () {
		return this.state.viewMode === "grid";
	};

	render() {
		const { currentFolder, currentPath, canEdit, selectedFiles, filesToCopie, hasFolderSelected, viewMode } = this.state;

		return (
			<div className="file-manager-container">
				<FileToolbar
					isSharedFolder={currentFolder?.isShared}
					newFolderOptions={{
						onItemClicked: this.onNewFolderClicked,
						disabled: false
					}}
					uploadOptions={{
						onItemClicked: this.onUploadClicked,
						disabled: false
					}}
					copyOptions={{
						onItemClicked: this.onCopyClicked,
						disabled: !canEdit

					}}
					duplicateOptions={{
						onItemClicked: this.onDuplicateClicked,
						disabled: !canEdit || hasFolderSelected
					}}
					cutOptions={{
						onItemClicked: this.onCutClicked,
						disabled: !canEdit
					}}
					pasteOptions={{
						onItemClicked: this.onPasteClicked,
						disabled: !canEdit || !filesToCopie.files.length
					}}
					deleteOptions={{
						onItemClicked: this.onDeleteClicked,
						disabled: !canEdit
					}}
					renameOptions={{
						onItemClicked: this.onRenameClicked,
						disabled: !canEdit || selectedFiles.length > 1
					}}
					refreshOptions={{
						onItemClicked: this.onRefreshClicked
					}}
					menuActionItem={{
						onItemClicked: this.onUploadClicked,
						disabled: true
					}}
					downloadOptions={{
						onItemClicked: this.onDownloadClicked,
						disabled: !canEdit || !this.canDownload()
					}}
					shareOptions={{
						onItemClicked: this.onShareClicked,
						disabled: !canEdit
					}}
					infoOptions={{
						onItemClicked: this.onInfoClicked,
						disabled: !canEdit || selectedFiles.length > 1
					}}
					viewModeOptions={{
						onItemClicked: this.toggleViewMode,
						icon: this.isGridView ? "la la-list" : "la la-th-large",
						title: this.isGridView ? "Ver em lista" : "Ver em grelha",
					}}
					menuActionOptions={{
						onItemClicked: this.onDownloadClicked,
						disabled: true
					}}
				/>

				<div className="file-manager__body">
					{hp.store.perms.canEdit ? 
						<FileTree 
							files={this.state.files} 
							onSelectedRow={this.handleOpenFile}
							customClassName={this.state.isCollapsedView ? 'collapsed' : ''}
						/>
						: null
					}

					<div className="file-manager__body-files">
						<div className="file-manager__body-files__toolbar">
							<BreadcrumbFile path={currentPath} onClick={this.handleBreadcrumbClick} onCollapsed={this.onCollapsed}/>
							<div className="search">
								<Search
									className="search"
									doSearch={this.handleSearchChange}
									placeholder="Procurar "
								/>
							</div>
						</div>
							{currentFolder && (
								<FileBrowser
									isGridView={this.isGridView}
									isCutting={filesToCopie.isCutting}
									canPaste={canEdit && filesToCopie.files.length}
									files={currentFolder.children ?? []}
									isSharedFolder={currentFolder?.isShared}
									onDoubleClickFileItem={this.handleDoubleClick}
									onClickFileItem={this.handleSelectedRow}
									onContextMenuClicked={this.handleContextMenuOption}
									itemACtions={{
										shareFile: this.onShareClicked,
										openFile: this.onOpen,
										copyUrlFile: (file) => CopyClipboard(file.url, __('files_copied_clipboard')),
									}}
									selectedFiles={selectedFiles}	
								/>
							)}
					</div>
				</div>
			</div>
		);
	}
}

export class InputFile extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			file: null,
			img: null
		}
		this.ref = React.createRef()
	}

	static getFileState(file) {
		if (!file || typeof file === 'string') {
			return {
				file: null,
				img: null
			}
		}
		const is_image = file.type.match(/^image\//) != null
		return {
			file: file,
			img: is_image ? URL.createObjectURL(file) : null
		}
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		if (!nextProps.hasOwnProperty('file') || nextProps.file === prevState.file) {
			return null;
		}
		return InputFile.getFileState(nextProps.file);
	}

	onChange = (e) => {
		if (e.currentTarget.files.length == 0) {
			return;
		}
		const state = InputFile.getFileState(e.currentTarget.files[0]);
		this.setState(state);
		if (this.props.model && this.props.name) {
			this.props.model[this.props.name] = e.currentTarget.files[0];
		}
		if (this.props.onChange) {
			this.props.onChange(e);
		}
	}

	componentDidUpdate() {
		const { model, name, file } = this.props
		const value = model && name ? model[name] : file

		if (!value && this.ref.current) {
			this.ref.current.value = ''
		}
	}


	onRemove = (e) => {
		e.preventDefault()
		this.setState({
			file: null,
			img: null
		});
		if (this.props.model && this.props.name) {
			this.props.model[this.props.name] = null;
		}
		if (this.props.onChange) {
			this.props.onChange(null);
		}
	}

	onEdit = (e) => {
		e.preventDefault()
		this.onShowFileManager();
	}

	getRemoveButton(transparency = 'btn-transparent') {
		return (
			!this.props.hasOwnProperty('readOnly') || this.props.readOnly == 0
				? <button key='x' type='button' className={classNames('btn xdel btn-circular', transparency)} onClick={this.onRemove}>
					<em className="la la-trash danger pointer" />
				</button>
				: null
		)
	}

	getEditButton(transparency = 'btn-transparent', classname = 'edt') {
		return (
			!this.props.hasOwnProperty('readOnly') || this.props.readOnly == 0
				? <button key='e' type='button' className={classNames('btn btn-circular pointer', classname, transparency)} onClick={this.onEdit}>
					<em className="la la-pencil" />
				  </button>
				: null
		)
	}

	addSelectedFile = () => {
		const { selectedFiles } = this.state;

		if (selectedFiles.length > 0) {
			const file = selectedFiles[0];
			const { model, name, onChange } = this.props;

			if (model && name) {
				model[name] = (file.url || file.path).replace(hp.settings.dns, '/');
			}
			this.setState({selectedFiles: null});
			if (onChange) {
				onChange(file);
			}
			this.forceUpdate();
		}
		mbox.dismiss();
	}

	onShowFileManager = () => {
		FileManager.Modal(selectedFiles => this.setState({ selectedFiles }), this.addSelectedFile);
	}

	render() {
		const { type, model, name, className, classNameImg, file, imageNone, readOnly, required, uploadFile } = this.props
		const as_image = type == 'image'
		let thumb
		const id = this.props.id || 'file'

		if (this.state.img) {
			thumb =
				<label htmlFor={id}>
					{required ? <img className='required' src="/public/admin/img/required.gif" alt="x" /> : null}
					<img src={this.state.img} className={classNameImg || null} />
					<div className="flex-center">
						{this.getEditButton(null)}
						{this.getRemoveButton(null)}
					</div>
					<span className='filename'>{this.state.file.name}</span>
				</label>
		}
		else if (this.state.file) {
			thumb =
				<label key='l' htmlFor={id}>
					<em className="la la-file-alt" />
					{this.state.file.name}
				</label>;
			thumb = [
				thumb,
				<div key='b' className="btn-ungroup">
					{this.getRemoveButton()}
					{this.getEditButton()}
				</div>
			];
		}
		else {
			const has_file = model && typeof model[name] == 'string' && model[name];
			let label = null;

			if (this.props.hasOwnProperty('label')) {
				label = this.props.label;
			}
			else if (has_file) {
				if (as_image) {
					label = [
						<img key='i' src={model[name]} className={classNameImg || null} />,
						<div key='b' className="btn-ungroup">
							{this.getRemoveButton()}
							{this.getEditButton()}
						</div>
					]
				}
				else {
					label = /(png|jpg|jpeg|gif|webp|bmp)/.test(model[name] || '')
						? <img key='img' src={file ? ('/' + file) : model[name]} className={classNameImg || null} />
						: <span key='legend' className='legend-label'>{model[name]}</span>

					label = [
						label,
						<div key='b' className="btn-ungroup">
							{this.getRemoveButton()}
							{this.getEditButton()}
						</div>
					]
				}
			}
			else if (imageNone) {
				label = [
					<img key='i' src={imageNone} />,
					this.getEditButton(null, 'xdel')
				]
			}
			else {
				label = 
					uploadFile 
						? 	<a className="btn btn-default">
								<em className="la la-upload" />
								{__('attrs_upload_file')}
							</a>
						: 	<button className="btn btn-default" onClick={this.onShowFileManager}>
								<em className="la la-upload" />
								{__('attrs_upload_file')}
							</button>
			}
			thumb = (label || required) &&
				<label htmlFor={id} className={has_file || this.props.label ? null : "none"}>
					{required ? <img className='required' src="/public/admin/img/required.gif" alt="x" /> : null}
					{label}
				</label>
		}
		return (
			<div className={classNames(className || "file", readOnly == true ? 'readonly' : null)} title={this.props.title || null}>
				{thumb}
				{this.props.children || null}
			</div>
		)
	}
}
